/* Native scroll remains available without JavaScript. The element lifecycle also
   handles Shopify's section replacement in the theme editor. */
if (!customElements.get('fk26-collection-carousel')) {
  customElements.define('fk26-collection-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fk26-collection-carousel__track');
      this.controls = this.querySelector('.fk26-collection-carousel__controls');
      if (!this.track || !this.controls) return;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.buttons = [...this.controls.querySelectorAll('button')];
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const slide = this.track.firstElementChild;
          const distance = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
          this.track.scrollBy({
            left: distance * Number(button.dataset.direction),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }, options);
      });
      this.update = () => {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = maxScroll <= 2;
        this.buttons[0].disabled = this.track.scrollLeft <= 2;
        this.buttons[1].disabled = this.track.scrollLeft >= maxScroll - 2;
      };
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
